export default __webpack_public_path__ + "static/media/ic_map.e97ef200.svg";